module.exports = __webpack_public_path__ + "img/log.2f959f41.png";